import React from "react";
import { FaSave, FaTimes, FaTrash, FaCheck } from "react-icons/fa"; // Exemple, tu peux changer
import theme from "../../../styles/theme";

const IconButton = ({
  icon,
  label,
  variant = "blue",
  onClick,
  disabled = false,
  position = "left", // "left" | "right" | "only"
  style = {},
}) => {
  const btnTheme = theme.buttons[variant] || theme.buttons.blue;
  const disabledTheme = theme.buttons.disabled;

  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: label && position !== "only" ? theme.spacing.xs : 0,
    backgroundColor: disabled ? disabledTheme.background : btnTheme.background,
    color: disabled ? disabledTheme.color : btnTheme.color,
    borderRadius: theme.borders.radius.md,
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
    fontFamily: theme.typography.button.fontFamily,
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    lineHeight: theme.typography.button.lineHeight,
    letterSpacing: theme.typography.button.letterSpacing,
    textTransform: theme.typography.button.textTransform,
    boxShadow: theme.shadows.sm,
    border: "none",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "background-color 0.2s ease",
    ...style,
  };

  return (
    <button
      style={baseStyle}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={(e) => {
        if (!disabled) e.target.style.backgroundColor = btnTheme.hover;
      }}
      onMouseLeave={(e) => {
        if (!disabled) e.target.style.backgroundColor = btnTheme.background;
      }}
    >
      {/* Icône seule */}
      {position === "only" && icon}

      {/* Icône à gauche */}
      {position === "left" && icon && <span>{icon}</span>}
      {label && <span>{label}</span>}

      {/* Icône à droite */}
      {position === "right" && icon && <span>{icon}</span>}
    </button>
  );
};

export default IconButton;
